<template>
  <div>
    <div class="container" v-if="isShow">
      <!-- 商机信息 -->
      <div class="card">
        <!-- <div class="title">
          <div style="flex: 10;">
            <svg class="icon" aria-hidden="true" style="float:left;margin-top:5px;margin-left:5px;">
              <use xlink:href="#icon-post"></use>
            </svg>
            <span style="margin-right:40px">{{boInfo.boName}}</span>
          </div>
          <div style="flex: 2;">
            <van-icon name="edit" color="#f8df0d" size="20px" class="icon-edit" style="padding-left:15px;" v-hasPermi="['scrm:bo:edit']" @click="edit"/>
            <van-icon name="delete" color="red" size="20px" class="icon-edit" v-hasPermi="['scrm:bo:remove']"/>
          </div>
        </div> -->
        <div class="title">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-post"></use>
          </svg>
          <span>{{boInfo.custName}}</span>
        </div>
        <div class="list-wrap van-hairline--top">
              <!-- <div class="item" style="width:100%">
                <span class="key">客户名称：</span>
                <span class="value">{{ boInfo.custName }}</span>
              </div> -->
              <div class="item" style="width:100%">
                <span class="key">业务类型：</span>
                <span class="value">{{ boInfo.businessTypeName }}</span>
              </div>
              <div class="item" style="width:100%">
                <span class="key">商机状态：</span>
                <span class="value">{{formatHandel('boStatus',boInfo.boStatus)}}</span>
              </div>
              <div class="item" style="width:100%">
                <span class="key">商机来源：</span>
                <span class="value">{{formatHandel('boSource',boInfo.boSource)}}</span>
              </div>
              <!-- <div class="item">
                <span class="key">分配状态：</span>
                <span class="value">{{formatHandel('distributeStatus',boInfo.distributeStatus)}}</span>
              </div> -->
                <div class="item" style="width:100%">
                <span class="key">意向度：</span>
                <span class="value">{{formatHandel('possibility',boInfo.possibility)}}</span>
                <!-- <span class="value">
                    <van-progress v-if="!isNaN(parseInt(boInfo.possibility))" style="width:100%;margin-top: 10px;" stroke-width="8" :pivot-text="formatHandel('possibility',boInfo.possibility)" :percentage="boInfo.possibility" />
                </span> -->
              </div>
              <div class="item" style="width:100%">
                <span class="key">商机阶段：</span>
                <span class="value">
                  <van-progress v-if="!isNaN(parseInt(boInfo.stageValue))" style="width:100%;margin-top: 10px;" :pivot-text="boInfo.stageName" stroke-width="8" :percentage="parseInt(boInfo.stageValue)" />
                </span>
                <!-- <span class="value">{{boInfo.stageName}}({{boInfo.stageValue}}%)</span> -->
              </div>
              <div class="item" style="width:100%" v-if="boInfo.deptName">
                <span class="key">跟进部门：</span>
                <span class="value">{{boInfo.deptName}}</span>
              </div>
              <div class="item" style="width:100%">
                <span class="key">跟进人：</span>
                <span class="value">{{boInfo.userName}}</span>
              </div>
              <!-- <div class="item" style="width:100%">
                <span class="key">销售预期：</span>
                <span class="value">{{boInfo.saleExpect}}</span>
              </div>
              <div class="item" style="width:100%">
                <span class="key">预期收益(元)：</span>
                <span class="value">{{boInfo.expectProfit}}</span>
              </div>
              <div class="item" style="width:100%">
                <span class="key">失败关键因素：</span>
                <span class="value">{{boInfo.failFactors}}</span>
              </div>
              <div class="item" style="width:100%">
                <span class="key">成功关键因素：</span>
                <span class="value">{{boInfo.successFactors}}</span>
              </div>  -->
              <!-- <div class="item" style="width:100%">
                <span class="key">客户地址：</span>
                <span class="value">{{boInfo.custAddress}}</span>
              </div> -->
            </div>
        <!-- <van-tabs v-model="active"> -->
          <!-- <van-tab title="基本信息">

          </van-tab> -->
          <!-- <van-tab title="分类信息">
            <div class="list-wrap van-hairline--top">

            </div>
          </van-tab> -->
        <!-- </van-tabs> -->
      </div>
      <!-- 操作按钮区 -->
      <van-grid class="grid-wrap" :column-num="3">
        <van-grid-item>
          <div class="flex-center" v-hasPermi="['scrm:bo:edit']" @click="edit">
            <van-icon name="edit" size="22" color="#07c160" />
            <span>修改</span>
          </div>
        </van-grid-item>
        <van-grid-item>
          <div class="flex-center" v-hasPermi="['scrm:bo:remove']" @click="remove">
            <van-icon name="delete" size="22" color="#ee0a24" />
            <span>删除</span>
          </div>
        </van-grid-item>
        <van-grid-item>
          <div class="flex-center" v-hasPermi="['cont:newContract:add']" v-if="isAdded" @click="toAddContract">
            <van-icon name="add-o" size="22" color="#1989fa" />
            <span>新增合同</span>
          </div>
          <div class="flex-center" v-if="boInfo.boStatus != '1'" @click="toContractDetail">
            <van-icon name="browsing-history-o" size="22" color="#1989fa" />
            <span>查看合同</span>
          </div>
        </van-grid-item>
      </van-grid>
      <!-- 跟进 联系人-->
      <cont-bo-tab :listVisitData="boInfo.visitList" :id="boInfo.boId" :custContactOptionsData="boInfo.contactList"
      :custStatusData="boInfo.custStatus" @handleaddvisit="addVisit" @handleAddContacts="addContacts" :quotedPriceList="boInfo.quotedPriceList" :userConList="boInfo.userConList"/>

      <!-- 添加跟进记录 -->
      <van-dialog v-model="visitShow" title="添加跟进记录" class="editVisit"  :beforeClose="visitBeforeClose" close-on-click-overlay>
        <van-form ref="addVisitForm" validate-trigger="onSubmit" class="formSty">
            <van-cell-group>
              <van-field readonly clickable v-model="visitForm.visitTypeName" @click="showPicker('visitType')" label="回访类型" placeholder="请选择回访类型" required />
              <van-field readonly clickable v-model="visitForm.contactIdName" label="联系人" @click="showPicker('contactId')" :rules="[{ required: true }]" placeholder="请选择联系人" required />
              <van-field v-model="visitForm.content" label="回访类容" type="textarea" :rules="[{ required: true }]" placeholder="请填写回访类容" required />
            </van-cell-group>
        </van-form>
      </van-dialog>

      <!-- 添加联系人 -->
      <van-dialog v-model="contactsShow" title="添加联系人" class="editVisit" :beforeClose="contactsBeforeClose" close-on-click-overlay>
        <van-form ref="addContactsForm" validate-trigger="onSubmit" class="formSty">
            <van-cell-group>
              <van-field v-model="contactsForm.contactName" label="联系人姓名" placeholder="请输入联系人姓名" :rules="[{ required: true }]" required />
              <van-field v-model="contactsForm.sexName" label="联系人性别" placeholder="请选择联系人性别" readonly
                @click="showPicker('sex')" :rules="[{ required: true }]" required />
              <van-field v-model="contactsForm.mobile" label="联系人手机" placeholder="请输入联系人手机" type="tel" maxLength="11"
                :rules="[
                  { required: true, message: '请填写您的手机号码！' },
                  { pattern: /^1[3456789]\d{9}$/, message: '手机号码格式错误！'}
                ]" required />
                <van-field v-model="contactsForm.jobs" label="联系人职务" placeholder="请输入联系人职务" :rules="[{ required: true }]" required />
            </van-cell-group>
        </van-form>
      </van-dialog>

      <van-popup v-model="picker.visible" position="bottom">
        <van-picker :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" @change="pickerChange" />
      </van-popup>
      <dialog-add :show='edit_show' :isAdd='false' :modifyObj="boInfo" @handleAddBoCancel='handleAddBoCancel' @beforeClose='addBoBeforeClose' ></dialog-add>
    </div>
  </div>
</template>

<script>
// import moment from 'moment'
import { getBo, addVisit, delBo, selectContByBoId, getSourceTree } from '@/api/scrm/mycust'
import { addContact } from '@/api/scrm/custcontact'
import ContBoTab from '../component/ContBoTab.vue'
// import { getDicts } from '@/api/system/dict/data'
import { Toast, Dialog } from 'vant'
import DialogAdd from '../component/DialogAddBo.vue'
export default {
  components: {
    ContBoTab,
    DialogAdd,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component
  },
  filters: {
    // timeFormat(val) {
    //   return moment(val).format('YYYY-MM-DD')
    // }
  },
  data() {
    return {
      contactsShow: false,
      edit_show: false,
      contactsForm: {},
      visitShow: false,
      picker: {
        visible: false,
        title: '',
        columns: [],
        formKey: ''
      },
      visitForm: {},
      minDate: new Date(2010, 0, 1),
      minDateStart: new Date(2010, 0, 1),
      pattern: '/^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/',
      boInfo: {},
      isShow: false,
      // 修改商机
      editCustShow: false,
      // 是否显示弹框
      show: false,
      // 生日
      showBirthdayCalendar: false,
      // 证件类型
      showPopupPicker: false,
      active: 0,
      form: {
        boId: null,
        boName: this.$route.query.boName,
        custType: this.$route.query.custType,
        custTypeName: this.$route.query.custTypeName,
        province: '',
        city: '',
        area: '',
        lng: '',
        lat: '',
        latLong: '',
        custAddress: '',
        contactList: [{
          contactName: '',
          callName: '',
          jobs: '',
          mobile: ''
        }]
      },
      options: {
        contactIdOptions: [],
        boSourceOptions: [],
        boStatusOptions: [],
        distributeStatusOptions: [],
        visitTypeOptions: [],
        possibilityOptions: [],
        sexOptions: []
      },
      isAdded: false,
      contract: {}
    }
  },
  async created() {
    await this.getOptions()
    await this.getBoInfo()
    const res = await selectContByBoId({ boId: this.boInfo.boId })
    if (res.code === 200) {
      this.contract = res.rows[0]
      if (res.total == 0) {
        // await Toast.fail('该商机已经签署合同，不能再次添加!')
        this.isAdded = true
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      document.title = 'SCRM-商机详情'
      // this.getBoInfo()
    },
    async getBoInfo() {
      const res = await getBo(this.$route.params.id)
      if (res.code === 200) {
        this.boInfo = res.data
        this.boInfo.possibilityName = this.formatHandel('possibility', this.boInfo.possibility)
        this.boInfo.boStageIdName = this.boInfo.stageName + this.boInfo.stageValue + '%'
        this.isShow = true
        // this.options.contactIdOptions = []
        const uLis = res.data.contactList || []
        for (let i = 0; i < uLis.length; i++) {
          const element = uLis[i]
          const item = {
            dictValue: element.contactId,
            dictLabel: element.contactName
          }
          this.options.contactIdOptions.push(item)
        }
      }
    },
    // 添加回访记录
    addVisit() {
      this.visitShow = true
    },
    // 添加联系人
    addContacts() {
      this.contactsShow = true
    },
    /** 转换业务类型数据结构 */
    businessNormalizer(node) {
      console.log(node)
      const arr = []
      if (node.children && node.children.length) {
        for (const i in node.children) {
          const item = {
            id: node.children[i].businessTypeId,
            text: node.children[i].businessTypeName
          }
          arr.push(item)
        }
      }
      return {
        id: node.businessTypeId,
        text: node.businessTypeName,
        children: arr
      }
    },
    formatHandel(type, value) {
      const options = type + 'Options'
      if (value || value == 0) {
        return this.selectDictLabel(this.options[options], value)
      } else {
        return ''
      }
    },
    // 修改商机
    handleUpdate(boId) {
    },
    showPicker(type) {
      this.picker.formKey = type
      const optionItem = type + 'Options'
      this.picker.columns = this.options[optionItem].map((ele) => ele.dictLabel)
      this.picker.visible = true
    },
    pickerConfirm(value, key) {
      const optionItem = this.picker.formKey + 'Options'
      const name = this.picker.formKey + 'Name'
      if (this.picker.formKey == 'sex') {
        this.contactsForm[this.picker.formKey] = this.options[optionItem][key].dictValue
        this.contactsForm[name] = this.options[optionItem][key].dictLabel
      } else {
        this.visitForm[this.picker.formKey] = this.options[optionItem][key].dictValue
        this.visitForm[name] = this.options[optionItem][key].dictLabel
      }
      this.picker.visible = false
    },
    pickerCancel() {
      this.picker.visible = false
    },
    pickerChange() { },
    edit() {
      // this.$router.push('/scrm/custBo/add?boId=' + this.boInfo.boId)
      this.edit_show = true
    },
    handleAddBoCancel() {
      this.edit_show = false
    },
    // 修改合同
    async addBoBeforeClose() {
      this.edit_show = false
      await this.getBoInfo()
    },
    async remove() {
      Dialog.confirm({
        message: '是否确认删除此条商机'
      })
        .then(() => {
          this.delete()
        })
        .catch(() => {
        // on cancel
        })
    },
    async delete() {
      const res = await delBo(this.boInfo.boId)
      if (res.code === 200) {
        await Toast.success('成功删除!')
        setTimeout(() => {
          this.$router.go(-1)
        }, 500)
      }
    },
    // 修改商机
    // async editCustBeforeClose(type, done) {
    //   if (type === 'confirm') {
    //     try {
    //       await this.$refs.editForm.validate()
    //       updateBo(this.form).then(response => {
    //         this.getBoInfo()
    //         Toast.success('修改成功!')
    //         this.editCustShow = false
    //       })
    //       done()
    //     } catch (err) {
    //       return done(false)
    //     }
    //     return done(false)
    //   } else {
    //     return done()
    //   }
    // },
    // 添加回访记录
    async visitBeforeClose(type, done) {
      if (type === 'confirm') {
        try {
          await this.$refs.addVisitForm.validate()

          this.visitForm.custId = this.boInfo.custId
          this.visitForm.custName = this.boInfo.custName
          this.visitForm.boId = this.boInfo.boId
          this.visitForm.boName = this.boInfo.boName
          this.visitForm.contactName = this.visitForm.contactIdName
          addVisit(this.visitForm).then(response => {
            // 选择商机时获取该商机的回访记录
            this.visitShow = false
            this.visitForm.content = null
            // this.visitForm.visitType = null
            // this.visitForm.contactId = null
            Toast.success('回访记录添加成功!')
            this.getBoInfo()
          })
          done()
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        return done()
      }
    },
    // 添加联系人
    async contactsBeforeClose(type, done) {
      if (type === 'confirm') {
        try {
          await this.$refs.addContactsForm.validate()
          this.contactsForm.custId = this.boInfo.custId
          addContact(this.contactsForm).then(response => {
            Toast.success('联系人添加成功!')
            this.getBoInfo()
          })
          done()
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        return done()
      }
    },
    getOptions() {
      // 商机来源
      // this.getDicts('crm_bo_source').then(res => {
      //   this.options.boSourceOptions = this.setDictToInt(res)
      // })
      getSourceTree().then(res => {
        this.options.boSourceOptions = res.rows.map(item => { return { dictLabel: item.custSourceName, dictValue: item.custSourceId } })
      })
      // 商机状态
      this.getDicts('crm_bo_status').then(res => {
        this.options.boStatusOptions = this.setDictToInt(res)
      })
      // 分配状态
      this.getDicts('cms_distribute_status').then(res => {
        this.options.distributeStatusOptions = this.setDictToInt(res)
      })
      this.getDicts('crm_visit_type').then(res => {
        this.options.visitTypeOptions = res.data
      })
      // 意向度
      this.getDicts('crm_bo_possibility ').then(res => {
        this.options.possibilityOptions = res.data
      })
      // 性别
      this.getDicts('sys_user_sex').then(res => {
        this.options.sexOptions = res.data
      })
    },
    formatDate(date) { // 时间格式化 2019-09-08
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      return year + '-' + month + '-' + day
    },
    async toAddContract() {
      const obj = {
        boId: this.boInfo.boId,
        custId: this.boInfo.custId,
        custName: this.boInfo.custName,
        boName: this.boInfo.boName,
        businessTypeId: this.boInfo.businessTypeId,
        businessTypeName: this.boInfo.businessTypeName,
        userId: this.boInfo.userId,
        userName: this.boInfo.userName
      }
      this.$router.push({
        path: '/cont/contract/add',
        query: obj
      })
    },
    toContractDetail() {
      this.$router.push({
        path: '/cont/approve/detail',
        query: { id: this.contract.contractId }
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import url("@/style/index.less");

/deep/.van-dialog__confirm{
  color: #ee0a24;
  border-top: 0.01333rem solid #ccc;
}

.editVisit{
    min-height: 9rem;
    height: 50%;
    top: 46%;
    .formSty{
      height: 100%; overflow: scroll; margin: 10px 5px;
    }
}
.editVisit /deep/.van-dialog__content {
  height: 83%;
  .van-field--error .van-field__control{
    font-size: 0.38rem;
  }
  .van-field__control{font-size: 0.38rem;}
}
.editVisit /deep/.van-dialog__content {
  height: 70%;
}
/deep/.van-tabs__line {
  position: absolute;
  bottom: 0.4rem;
  left: 0;
  z-index: 1;
  width: 1rem;
  height: 0.08rem;
  background-color: #bbb;
  border-radius: 0.08rem;
  top:1rem;
}
/deep/.van-tab__text{
  font-weight: bold;
}
</style>
